"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ethers_1 = require("ethers");
const bignumber_1 = require("../utils/bignumber");
const parameters_1 = __importDefault(require("./parameters"));
exports.default = (chainID) => {
    return Object.assign({ ZERO: ethers_1.BigNumber.from(0), BASE_TOKENS: (0, bignumber_1.ether)(1), BASE_PARAMS: (0, bignumber_1.gwei)(1), DECIMAL_TOKENS: 18, DECIMAL_PARAMS: 9 }, (0, parameters_1.default)(chainID));
};
__exportStar(require("./contracts"), exports);
__exportStar(require("./layerZero"), exports);
__exportStar(require("./merkl"), exports);
__exportStar(require("./tokens"), exports);
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map